import React from 'react';
import { Node } from '@uncinc/react-drupal-core';

import './style.scss';
import PagerLoadMore from '../../../components/PagerLoadMore';

const ViewCampaignArticles = (props) => {
  const { onLoadMore, entities, pager, setCurrentPage } = props;

  const currentPage = pager.get('current_page') ?? 0;
  const totalPages = pager.get('total_pages') ?? 0;
  const totalItems = pager.get('total_items') ?? 0;

  return (
    <div className="View CampaignArticles">
      <div className="row">
        {entities.map((entity, index) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);
          const className = 'col-12 col-md-6 col-lg-4 ArticlesAllOverview__item-wrapper';

          return (
            <div key={`${uuid}:${langcode}`} className={className}>
              <Node
                id={id}
                isActivePath
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </div>
      {/* Start of Pager */}
      { entities.size < totalItems && (
        <div className="ViewRecentContentOverview__pager">
          <PagerLoadMore currentPage={currentPage} totalPages={totalPages} setCurrentPage={setCurrentPage} onLoadMore={onLoadMore} />
        </div>
      )}
      {/* End of Pager */}
    </div>
  );
};

export default ViewCampaignArticles;
